import React from 'react'
import styled from '@emotion/styled'
import { Tooltip } from 'antd'
import { Ellipsis, EllipsisTooltip } from 'components'
import { colors, severityColors } from 'style/theme'
import { MoreItems, ShowStyledItems } from 'components'
import { ScanScore } from 'components/Score'
import {RECORD_STATUS} from './ScanViewData';

const MoreCountNoBorder = styled.div(({ color }) => ({
	height: 30,
	width: '100%',
	lineHeight: '28px',
	color: color,
	fontSize: '0.9rem'
}))

const colorBrokenLink = { color: colors.error.color };
const colorWorkingLink = { color: colors.brandLink.color };

function PageTooltip({url, errorDescription}){
	return (
		<>
			<EllipsisTooltip>{url}</EllipsisTooltip> 
			{ errorDescription && 
				<EllipsisTooltip style={{color: 'rgb(245, 100, 100)' }} >Error: {errorDescription}</EllipsisTooltip>
			}
		</>
	)
}

export default [
	{
		title: 'PAGE',
		dataIndex: 'url',
		width: '35%',
		render(url, record){
			let documentLinkState = record && record.status === RECORD_STATUS.COMPLETE ? true : false;
			let errorDescription = record && record.error_description;
			return (
				<Tooltip placement="right" title={<PageTooltip url={url} errorDescription={errorDescription} />}>
					{record.type != "flow" &&<a target="_blank" href={url} style={documentLinkState ? colorWorkingLink : colorBrokenLink }>
						<Ellipsis>{url}</Ellipsis>
					</a>}
					{record.type == "flow" && <Ellipsis>{url}</Ellipsis>}
				</Tooltip>
			)
		}
	},
	{
		title: 'SCORE',
		dataIndex: 'score',
		align: 'center',
		render(score, record) {
			let isValid = record && record.status !==  RECORD_STATUS.ERROR;
			return isValid && <ScanScore score={score} thickness={8} width={36} labelSize={14} />
		}
	},
	{
		title: 'DOCUMENT ERRORS',
		dataIndex: 'document_error_codes',
		align: 'center',
		render(document_error_codes) {
			var errCount = 0;
			document_error_codes = document_error_codes.map((item) => {
				errCount += item.count;
				item.color = severityColors[item.severity.toLowerCase()]
				return item
			});
			if(!!document_error_codes.length){
				return (
					<ShowStyledItems
						moreItems={document_error_codes}
						renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{errCount}</MoreCountNoBorder>}
					/>
				)
			}
		}
	},
	{
		title: 'SELECTORS ERRORS',
		dataIndex: 'selector_error_codes',
		align: 'center',
		render(selector_error_codes) {
			var errCount = 0;
			selector_error_codes = selector_error_codes.map((item) => {
				errCount += item.count;
				item.color = severityColors[item.severity.toLowerCase()]
				return item
			})
			if(!!selector_error_codes.length){
				return (
					<ShowStyledItems
						moreItems={selector_error_codes}
						renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{errCount}</MoreCountNoBorder>}
					/>
				)
			}
		}
	},
	{
		title: 'LABELS',
		dataIndex: 'labels',
		render(labels, record) {
			var labels_arr = Object.keys(labels).map((label) => {
				let item = { "name" : label };
				if(record.document_labels && record.document_labels.hasOwnProperty(label)){
					item.tooltip = record.document_labels[label].selector;
				}

				return item;
			})
			return <MoreItems items={labels_arr} />
		}
	}
]
